import { routes } from "routing";
import { path } from "routes-utils";

export const TAB_BAR_HIDDEN_PATHS = [
  "/$",
  // Pre-auth flow (canonical /auth/* registry paths) and the legacy /authentication/*
  // paths that emailed links still redirect through.
  "/auth(/.*)?$",
  `/${path.authentication}(/.*)?$`,
  `/${path.edit}(/.*)?$`,
  `/${path.account}/${path.profile}/${path.edit}`,
  `${routes.dev.menu.path}(/.*)?$`,
  `${routes.activityFeed.path}(/.*)?$`,
  `/${path.account}/${path.itineraries}(/.*)?$`,
  // Inside a room or one of its info/members/notifications/manage screens (but not
  // the chat list itself, which keeps the tab bar).
  `${routes.chat.list.path}/.+`,
  `/${path.setup}/${path.addUsers}`,
  `${routes.clocks.path}(/.*)?$`,
  `${routes.createItinerary.path}$`,
];

export const TAB_BAR_HIDDEN_PATHS_REGEX = TAB_BAR_HIDDEN_PATHS.map((p) => new RegExp(`^${p}`, "i"));

// Item detail viewers live under /items/* (see registry `routes.item`). Legacy
// /item/* paths only exist as redirects, so the settled URL is always /items.
export const ITEM_PATHS = [/^\/items(\/.*)?$/i];
